import React from 'react';
import PropTypes from 'prop-types';

// jl-design-system
import Tooltip from 'jl-design-system/components/tooltip/Tooltip';

import supportedCreditCardTypes from '../../../../constants/supportedCreditCardTypes';

const DEFAULT_TOOLTIP_MESSAGE = 'This is the last 3 digits on the back of your card';
const AMERICAN_EXPRESS_TOOLTIP_MESSAGE = 'This is the 4 digits on the front of the card above the long card number';

const SecuredCardInputTooltip = ({ cardType }) => (
  <Tooltip
    anchor="left"
    data-test="secured-card-input-tooltip"
    icon
    id="clickSecuredCardInputTooltip"
  >
    <p data-test="secured-card-instruction">
      {cardType === supportedCreditCardTypes.AMERICAN_EXPRESS ?
        AMERICAN_EXPRESS_TOOLTIP_MESSAGE : DEFAULT_TOOLTIP_MESSAGE}
    </p>
  </Tooltip>
);

SecuredCardInputTooltip.propTypes = {
  cardType: PropTypes.string,
};

SecuredCardInputTooltip.defaultProps = {
  cardType: null,
};

export default SecuredCardInputTooltip;
